// re-export {default} from '' when re-exporting default class
// re-export {instanceName} from ''  when re-exporting service instance
import Guide from './Guide.js';
export default Guide;



// WEBPACK FOOTER //
// ./src/components/Guide/index.js